<template>
  <div>
    <h1>EXSBWarehouseItem List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <span v-if="view">
     <pagination
       :view="view"
       @getPage="getPage($event)"
     ></pagination>
    </span>

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>createdAt</th>
            <th>updatedAt</th>
            <th>deletedAt</th>
            <th>createdBy</th>
            <th>updatedBy</th>
            <th>deletedBy</th>
            <th>state</th>
            <th>warehouse</th>
            <th>item</th>
            <th>quantity</th>
            <th colspan="2" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['@id'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['createdAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['updatedAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['deletedAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['createdBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['updatedBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['deletedBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['state'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['warehouse'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['item'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                {{ item['quantity'] }}
              </router-link>
            </td>
            <td>
              <router-link
                :to="{name: 'EXSBWarehouseItemShow', params: { id: item['@id'] }}">
                <span
                  class="fa fa-search"
                  aria-hidden="true" />
                <span class="sr-only">Show</span>
              </router-link>
            </td>
            <td>
              <router-link :to="{name: 'EXSBWarehouseItemUpdate', params: { id: item['@id'] }}">
                <span
                  class="fa fa-pencil"
                  aria-hidden="true" />
                <span class="sr-only">Edit</span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'EXSBWarehouseItemCreate' }"
      class="btn btn-primary">Create</router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'exsbwarehouseitem/del/deleted',
    error: 'exsbwarehouseitem/list/error',
    items: 'exsbwarehouseitem/list/items',
    isLoading: 'exsbwarehouseitem/list/isLoading',
    view: 'exsbwarehouseitem/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'exsbwarehouseitem/list/default'
  })
}
</script>
